<app-form-element [control]="formControl" [id]="id" [label]="label" [required]="required" [twoColumns]="twoColumns">
  <div [class.invalid]="!formControl.valid">
    @for (item of values(); track $index; let i = $index) {
      <div class="flex flex-wrap md:flex-row w-full mb-6 gap-2 items-center">
        <div class="flex flex-col gap-1">
          <label for="snomedIdentifier">{{ 'VARIABLES.SNOMED_CT_ID' | translate }}</label>
          <p-inputNumber
            (ngModelChange)="updateItemId(i, $event)"
            [disabled]="formControl.disabled"
            [format]="false"
            [ngModel]="item.identifier"
            inputId="snomedIdentifier" />
        </div>

        <div class="flex flex-col gap-1 flex-1">
          <label for="snomedTitle">{{ 'VARIABLES.SNOMED_CT_TITLE' | translate }}</label>
          <div class="flex gap-1">
            <input
              (ngModelChange)="updateTitle(i, $event)"
              [ngModel]="item.title"
              class="grow"
              id="snomedTitle"
              maxlength="100"
              pInputText />
            @if (!formControl.disabled) {
              <p-button
                (onClick)="add(i)"
                class="first-button"
                icon="fal fa-plus"
                iconPos="left"
                type="button"></p-button>
            }
            @if (!formControl.disabled) {
              <p-button (onClick)="remove(i)" icon="fal fa-minus" iconPos="left" type="button"></p-button>
            }
          </div>
        </div>
      </div>
      @if (values().length > 1 && i !== values().length - 1) {
        <hr />
      }
    }
    @if (!values().length && !formControl.disabled) {
      <p-button (onClick)="add()" class="first-button" icon="fal fa-plus" iconPos="left" type="button"></p-button>
    }
  </div>
</app-form-element>
